import ManageHomeLayout from '../components/organisms/ManageHomeLayout';
import axios from 'axios';
import { useState } from 'react';
import config from '../config';
import { useQuery } from 'react-query';

const ManageHome = () => {
  const [students, setStudents] = useState([]);
  const [homeCatStudents, setHomeCatStudents] = useState([]);

  useQuery('getUnassignedStudents', async () => {
    const formData = new FormData();
    formData.append('auth', localStorage.getItem('token'));
    const output = await axios.post(config.STUDENTS_API, formData);
    setStudents(output.data.response.students);
  });

  useQuery('getHomeCats', async () => {
    const formData = new FormData();
    formData.append('auth', localStorage.getItem('token'));
    formData.append('mode', 'getHomecatSpread');
    const output = await axios.post(config.STUDENTS_API, formData);
    setHomeCatStudents(output?.data?.response?.studentSpread);
  });

  return (
    <ManageHomeLayout students={students} homeCatStudents={homeCatStudents} />
  );
};

export default ManageHome;
